import React from 'react';
import { Game_DesiredActions as GameDesiredActions } from '../Game_DesiredActions';

const ActionsPanel = React.memo(function ActionsPanel({
  enableShortcuts,
  onRequestAction,
  onScavengePreviewChange,
  queuedWorldIntent,
}) {
  return (
    <div className="actions-panel">
      <GameDesiredActions
        enableShortcuts={enableShortcuts}
        onRequestAction={onRequestAction}
        onScavengePreviewChange={onScavengePreviewChange}
        suppressQueuedAction={Boolean(queuedWorldIntent)}
      />
      {queuedWorldIntent ? (
        <div
          aria-live="polite"
          className="actions-panel__next"
          role="status"
        >
          Next: <strong>{queuedWorldIntent.label}</strong>
        </div>
      ) : null}
    </div>
  );
});

export default ActionsPanel;
